import React from 'react'
import LowCreditModal from './LowCreditModal'
import ScheduleModel from './ScheduleModel'
import SelectMediaModel from './SelectMediaModel'
import ProgressModal from './ProgressModal'
import BlockedNumbersModal from './BlockedNumbersModal'
import InactiveGatewayModal from './InactiveGatewayModal'
import InternationalModeInfoModal from './InternationalModeInfoModal'
import { conicColors } from './OtherUtils'

const ModeLindex = (props) => {
    const { open, handleCancel, UserData, openScheduleModel, handleCancelScheduleModel, HandleScheduleTime, HandleSchedule, scheduleDate, scheduleTime, openMediaModel,handleCancelMediaModel, HandleUploadImage, requestType, handleCustomMedia, progress, isModalVisible, loading, resetCampaign, navigate, blockedNumbersModal, blockedNumbersSample, handleRemoveBlockedNumbers, handleCloseBlockedModal, allNumbers, blockNumbers, number, inactiveGatewayModal, inactiveGatewayMessage, inactiveGatewayGroups, handleRemoveInactiveNumbers, handleCloseInactiveGatewayModal, internationalInfoOpen, handleCloseInternationalInfo,
    } = props
    return (
        <>
            <BlockedNumbersModal
                isVisible={blockedNumbersModal}
                blockedNumbersSample={blockedNumbersSample}
                handleRemoveBlockedNumbers={handleRemoveBlockedNumbers}
                handleCloseBlockedModal={handleCloseBlockedModal}
                allNumbers={allNumbers}
                blockNumbers={blockNumbers}
                number={number}
            />
            <InactiveGatewayModal
                isVisible={inactiveGatewayModal}
                message={inactiveGatewayMessage}
                inactiveGatewayGroups={inactiveGatewayGroups}
                handleRemoveInactiveNumbers={handleRemoveInactiveNumbers}
                handleClose={handleCloseInactiveGatewayModal}
            />
            <InternationalModeInfoModal
                open={internationalInfoOpen}
                onClose={handleCloseInternationalInfo}
            />
            {/* for belance alert  */}
            <LowCreditModal open={open} handleCancel={handleCancel} UserData={UserData} />
            {/* schedule model  */}
            <ScheduleModel
                openScheduleModel={openScheduleModel}
                handleCancelScheduleModel={handleCancelScheduleModel}
                HandleScheduleTime={HandleScheduleTime}
                HandleSchedule={HandleSchedule}
                loading={loading}
                scheduleSelected={Boolean(scheduleDate && scheduleTime)}
            />
            {/* model for media file  */}
            <SelectMediaModel
                openMediaModel={openMediaModel}
                handleCancelMediaModel={handleCancelMediaModel}
                HandleUploadImage={HandleUploadImage}
                requestType={requestType}
                handleCustomMedia={handleCustomMedia}
            />
            {/* progress model */}
            <ProgressModal
                progress={progress}
                isModalVisible={isModalVisible}
                loading={loading}
                conicColors={conicColors}
                resetCampaign={resetCampaign}
                navigate={navigate}
            />
        </>
    )
}

export default ModeLindex
